import api, { handleApiError } from './client';

export const bookingService = {
  // --- Admin: Templates ---
  getTemplates: async () => {
    try {
      const response = await api.get('/api/booking/templates');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching booking templates:', error);
      return handleApiError(error, 'Errore nel caricamento dei template slot');
    }
  },

  getTemplateById: async (id) => {
    try {
      const response = await api.get(`/api/booking/templates/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching booking template:', error);
      return handleApiError(error, 'Errore nel caricamento del template');
    }
  },

  createTemplate: async (data) => {
    try {
      const response = await api.post('/api/booking/templates', data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error creating booking template:', error);
      return handleApiError(error, 'Errore nella creazione del template');
    }
  },

  updateTemplate: async (id, data) => {
    try {
      const response = await api.put(`/api/booking/templates/${id}`, data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error updating booking template:', error);
      return handleApiError(error, 'Errore nell\'aggiornamento del template');
    }
  },

  deleteTemplate: async (id) => {
    try {
      const response = await api.delete(`/api/booking/templates/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error deleting booking template:', error);
      return handleApiError(error, 'Errore nell\'eliminazione del template');
    }
  },

  // --- Admin: Overrides ---
  getOverrides: async (params = {}) => {
    try {
      const response = await api.get('/api/booking/overrides', { params });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching booking overrides:', error);
      return handleApiError(error, 'Errore nel caricamento delle eccezioni slot');
    }
  },

  createOverride: async (data) => {
    try {
      const response = await api.post('/api/booking/overrides', data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error creating booking override:', error);
      return handleApiError(error, 'Errore nella creazione dell\'eccezione slot');
    }
  },

  deleteOverride: async (id) => {
    try {
      const response = await api.delete(`/api/booking/overrides/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error deleting booking override:', error);
      return handleApiError(error, 'Errore nell\'eliminazione dell\'eccezione');
    }
  },

  // --- Admin: Bookings & Slots ---
  getAdminSlots: async (params = {}) => {
    try {
      const response = await api.get('/api/booking/slots', { params });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching admin slots:', error);
      return handleApiError(error, 'Errore nel caricamento degli slot');
    }
  },

  getBookings: async (params = {}) => {
    try {
      const response = await api.get('/api/booking/bookings', { params });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching bookings:', error);
      return handleApiError(error, 'Errore nel caricamento delle prenotazioni');
    }
  },

  adminCancelBooking: async (id) => {
    try {
      const response = await api.delete(`/api/booking/bookings/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error cancelling booking by admin:', error);
      return handleApiError(error, 'Errore nella cancellazione della prenotazione');
    }
  },

  // --- Settings ---
  getSettings: async () => {
    try {
      const response = await api.get('/api/booking/settings');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching booking settings:', error);
      return handleApiError(error, 'Errore nel caricamento delle impostazioni prenotazioni');
    }
  },

  updateSettings: async (data) => {
    try {
      const response = await api.put('/api/booking/settings', data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error updating booking settings:', error);
      return handleApiError(error, 'Errore nell\'aggiornamento delle impostazioni prenotazioni');
    }
  },

  // --- Portal Athlete ---
  getAvailableSlots: async ({ startDate, endDate, courseId } = {}) => {
    try {
      const params = { startDate, endDate, courseId: courseId || undefined };
      const response = await api.get('/api/portal/booking/available-slots', { params });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching portal available slots:', error);
      return handleApiError(error, 'Errore nel caricamento degli slot disponibili');
    }
  },

  getMyCourses: async () => {
    try {
      const response = await api.get('/api/portal/booking/my-courses');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching athlete courses:', error);
      return handleApiError(error, 'Errore nel caricamento dei tuoi corsi');
    }
  },

  getMyBookings: async () => {
    try {
      const response = await api.get('/api/portal/booking/my-bookings');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching athlete bookings:', error);
      return handleApiError(error, 'Errore nel caricamento delle tue prenotazioni');
    }
  },

  bookSlot: async ({ bookingSlotId, courseSubscriptionId, courseId }) => {
    try {
      const response = await api.post('/api/portal/booking/book', {
        bookingSlotId,
        courseSubscriptionId,
        courseId
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error booking slot:', error);
      return handleApiError(error, 'Errore durante la prenotazione');
    }
  },

  cancelBooking: async (bookingId) => {
    try {
      const response = await api.delete(`/api/portal/booking/${bookingId}/cancel`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error cancelling booking:', error);
      return handleApiError(error, 'Errore durante la cancellazione della prenotazione');
    }
  }
};

export default bookingService;
